var _style, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Good News Logo Horizontal",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 357.92 99.05",
    style: {
      enableBackground: "new 0 0 357.92 99.05"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "209.29,55.04 208.87,55.04 196.54,1.4 181.4,1.4 181.4,97.79 193.31,97.79 193.31,33.88 193.88,33.88  207.61,97.79 221.48,97.79 221.48,1.4 209.29,1.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "240.66,52.52 253.42,52.52 253.42,39.35 240.66,39.35 240.66,14.3 256.36,14.3 256.36,1.4 226.93,1.4  226.93,97.79 256.64,97.79 256.64,84.75 240.66,84.75 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "303.85,60.37 303.43,60.37 297.82,1.4 283.52,1.4 277.92,60.65 277.64,60.65 272.45,1.4 258.58,1.4  270.07,98.07 283.94,98.07 290.11,31.36 290.67,31.36 296.84,98.07 309.73,98.07 320.66,1.4 308.75,1.4 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.25,47.34l-5.05-9.67c-2.38-4.62-7.43-11.32-7.43-18.04c0-4.62,0.84-7.57,4.2-7.57 c3.5,0,4.48,6.73,4.62,15.42h12.61c0.14-19.76-4.76-27.33-17.1-27.33c-12.89,0-17.8,9.39-17.8,20.46c0,10.79,4.48,16.92,8.55,25.05 l7.01,13.17c4.35,8.27,6.59,14.71,6.59,20.32c0,4.07-0.7,7.43-4.07,7.43c-4.06,0-5.32-5.05-5.32-16.82h-13.03 c-0.98,21.58,6.59,29.29,18.08,29.29c11.91,0,17.8-9.67,17.8-20.74C357.92,66.82,352.6,55.88,348.25,47.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.78,0C7.01,0,0,7.29,0,18.5v62.33C0,91.9,6.17,99.05,18.64,99.05c11.63,0,17.94-8.13,17.94-19.06V44.11 H18.22v12.05h5.33v23.27c0,3.22-1.12,6.17-4.76,6.17c-3.22,0-4.77-2.38-4.77-5.89V19.34c0-3.22,0.7-6.03,4.77-6.03 c3.36,0,4.76,2.1,4.76,5.75v15.56h13.03V17.66C36.58,7.29,30.13,0,18.78,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.44,1.4h-18.36v96.39h18.08c10.65,0,18.64-6.03,18.64-18.22V18.78C161.8,7.57,153.82,1.4,143.44,1.4  M147.93,78.31c0,3.22-1.12,6.45-5.75,6.45h-3.22V14.3h3.22c4.2,0,5.75,2.52,5.75,5.75V78.31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.4,60.82c11.63,0,19.06-7.15,19.06-19.76V20.32c0-12.05-7.43-18.92-18.78-18.92 c-11.49,0-18.92,7.01-18.92,19.34v20.18C40.76,53.25,46.37,60.82,59.4,60.82 M54.92,19.76c0-2.38,1.12-4.9,4.62-4.9 c3.36,0,4.76,2.24,4.76,5.05v21.72c0,2.52-0.84,5.75-4.76,5.75c-3.5,0-4.62-3.08-4.62-5.61V19.76z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.28,60.82c11.63,0,19.06-7.15,19.06-19.76V20.32c0-12.05-7.43-18.92-18.78-18.92 c-11.49,0-18.92,7.01-18.92,19.34v20.18C82.64,53.25,88.25,60.82,101.28,60.82 M96.8,19.76c0-2.38,1.12-4.9,4.62-4.9 c3.36,0,4.76,2.24,4.76,5.05v21.72c0,2.52-0.84,5.75-4.76,5.75c-3.5,0-4.62-3.08-4.62-5.61V19.76z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.3,67.2c-4.64,3.37-9.29,6.75-13.93,10.12c19.83,27.29,60.52,27.29,80.35,0 c-4.64-3.37-9.28-6.75-13.93-10.12C93.85,85.03,67.26,85.03,54.3,67.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.0315b480000830479abd661504d84d2d.svg";
export { ForwardRef as ReactComponent };